import { render } from "./TermsAndConditionsText.vue?vue&type=template&id=3cbcd7dc&scoped=true&ts=true"
import script from "./TermsAndConditionsText.vue?vue&type=script&lang=ts"
export * from "./TermsAndConditionsText.vue?vue&type=script&lang=ts"

import "./TermsAndConditionsText.vue?vue&type=style&index=0&id=3cbcd7dc&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cbcd7dc"]])

export default __exports__